import React from 'react';

const LoadingIndicator = () => {
    return (
        <div className="loading-container">
            <div className="spinner"></div>
        </div>
    );
};

export default LoadingIndicator;
